<!-- Table header / menu templates -->
<ng-template #headerRow let-isMenu="isMenu", let-hide="hide" >
  <div class="header-row" [ngStyle]="{'grid-column-end': gridColumnEnd }" [ngClass]="{hide: hide, 'menu-row': isMenu}">
    <div *ngIf="!nested && !readOnly" [ngStyle]="{zIndex: nested ? 10000 : 15000 }" [class]="'cell chbox ' + (isMenu ? '' : 'header')">
      <mat-checkbox 
        color="primary" (change)="toggleAll()" 
        [checked]="selectedIds.size && selectedIds.size === items.length" 
        [indeterminate]="!!selectedIds.size && selectedIds.size < items.length"
      ></mat-checkbox>
    </div>
    <ng-container *ngIf="isMenu" [ngTemplateOutlet]="menu"></ng-container>
    <ng-container *ngIf="!isMenu" [ngTemplateOutlet]="headers"></ng-container>
  </div>
</ng-template>

<ng-template #menu>
  <div class="menu" [ngStyle]="{'grid-column-end': gridColumnEnd, zIndex: nested ? 10000 : 15000 }">
    <div class="selected-count" *ngIf="!selectedPageItems || pages.length === 1">{{ (selectedIds.size === items?.length ? 'All ' : '') + selectedIds.size + ' selected' }}</div>
    <div class="selected-count" *ngIf="selectedPageItems && pages.length !== 1">
      {{ selectedIds.size + ' on the page were selected.' }}  
      <div class="select-all" (click)="selectAll()">Select all {{ items.length }}</div>
    </div>

    <div class="menu-method" [ngClass]="{ disabled: menuDisabled }" *ngFor="let menuItem of menuItems" (click)="menuDisabled ? null : callMethod(menuItem.method, $event)">{{ menuItem.title }} </div>
  </div>
</ng-template>

<ng-template #headers>
  <div class="header cell" *ngFor="let column of columns" [ngStyle]="{zIndex: nested ? 10000 : 15000 }" [ngClass]="{ hideTitle: column?.hideTitle, nested: nested, selected: selectedColumn === column?.id }" (click)="toggleSortByColumn(column)">
    <span *ngIf="!column?.hideTitle" [innerHTML]="column?.title"></span>
    <sort-icon *ngIf="!!column?.sortingFunction" [up]="!columnAscendingMap[column?.id]"></sort-icon>
  </div>
  <div class="filler header cell" [ngStyle]="{zIndex: nested ? 10000 : 15000 }" [ngClass]="{ nested: nested }"></div>
</ng-template>

<ng-template #row let-item="item">
  <div class="row" (click)="selectRow(item)" >
    <div *ngIf="!nested && !readOnly" class="chbox cell" [ngClass]="{ withChild: openedRows[item.id] === 'expand'}" (click)="toggleItem(item.id, $event)">
      <div *ngIf="!!item.seen" (click)="toggleSeen($event, item)" class="hover-bar" [ngClass]="{ unseen: item.seen !== 'seen', condensed: condensedView }">
        <div class="color-bar"></div>
      </div>
      <mat-checkbox [ngClass]="{ dim: item.dimmed }" color="primary" [checked]="selectedIds.has(item.id)" (change)="toggleItem(item.id)" (click)="$event.stopPropagation()"></mat-checkbox>
    </div>
    <div class="cell" [ngClass]="{hideTitle: column?.hideTitle, first: first && !nested && showNested, withChild: openedRows[item.id] === 'expand'}" *ngFor="let column of columns; first as first; trackBy: trackByPagination">
      <div class="arrow-holder" (click)="toggleOpenRow(item, $event)" *ngIf="first && !nested && showNested" [ngClass]="{condensed: condensedView, readOnly: readOnly}" >
        <mat-icon [ngClass]="{grey: !item.nestedIds?.length}">{{openedRows[item.id] !== 'expand' ? 'arrow_right' : 'arrow_drop_down'}}</mat-icon>
      </div>
      <div class="inner-cell" [ngClass]="{dim: item.dimmed, nested: nested}">
        <div class="dash" *ngIf="!item[column?.id]">&ndash;</div>
        <ng-container 
          *ngIf="!!item[column?.id]"
          [ngTemplateOutlet]="this[column?.templateId]" 
          [ngTemplateOutletContext]="{item: item, data: item[column?.id], column: column}">
        </ng-container>
      </div>
      <ng-container *ngIf="!!first && item.activeDotMenuOptions?.size && !readOnly">
        <div style="flex:1;"></div>
        <div class="dot-menu-holder" [matMenuTriggerFor]="dotMenu" (onMenuOpen)="dotMenuOpened(item.id)" (onMenuClose)="openDotMenu = null" (click)="$event.stopPropagation()">
          <icon class="dots" [ngClass]="{visible: openDotMenu === item.id}" matIcon="more_vert"></icon>
        </div>
        <mat-menu #dotMenu="matMenu" xPosition="before">
          <button mat-menu-item *ngFor="let optionId of item.activeDotMenuOptions" 
            (click)="callSingleMethod(dotMenuItems[optionId].method, item, $event)" >{{ dotMenuItems[optionId].title }}</button>
        </mat-menu>
      </ng-container>
    </div>
    <div class="filler cell" [ngClass]="{ withChild: openedRows[item.id] === 'expand'}"></div>
  </div>
  <div *ngIf="!nested && openedRows[item.id] === 'expand'" class="nested-table-row" [ngStyle]="{'grid-column-end': gridColumnEnd }" >
    <nested-table 
      [nestedIds]="item.nestedIds"
      [nested]="true"
      [columns]="nestedColumns"
      [columnsById]="nestedColumnsById"
      [nestedData]="nestedData"
      [parentId]="item.id"
      [parent]="item"
      [defaultSelectedColumnId]="defaultNestedColumnId"
    ></nested-table>
  </div>
</ng-template>

<!-- Table -->
<div *ngIf="nested && !nestedIds.length" class="no-nested-row">{{ parent.noNestedText }}</div>

<div *ngIf="((nested && !!nestedIds.length) || !nested) && { showMenu: selectedIds.size } as vars" [ngClass]="{nestedOpen: !!rowsOpen, nested: nested }" class="table_holder">
  <div class="table" [ngClass]="{condensed: condensedView && !nested, nested: nested, expanded: !condensedView && !nested, showMenu: vars.showMenu}" [ngStyle]="{'grid-template-columns': gridTemplateColumns }">
    <ng-container [ngTemplateOutlet]="headerRow" [ngTemplateOutletContext]="{isMenu: true, hide: !vars.showMenu}"></ng-container>
    <ng-container [ngTemplateOutlet]="headerRow" [ngTemplateOutletContext]="{isMenu: false, hide: vars.showMenu}"></ng-container>
    <div class="header-row with-message" *ngIf="!!message" [ngStyle]="{'grid-column-end': gridColumnEnd }">
      <div [ngStyle]="{zIndex: nested ? 10000 : 15000 }" [class]="'cell chbox'"></div>
      <div class="menu message" [ngStyle]="{'grid-column-end': gridColumnEnd, zIndex: nested ? 10000 : 15000 }"  [innerHTML]="helpers.strWithBreak(message)"></div>
    </div>
    <ng-container *ngIf="!nested">
      <div class="nested-table-row empty" [ngStyle]="{'grid-column-end': gridColumnEnd }" *ngIf="!hadItemsBeforeFiltering && !!emptyMessage && !items?.length">
        {{ emptyMessage }}
      </div><!-- First way to handle empty table: message from inputs -->
      <div class="nested-table-row empty" [ngStyle]="{'grid-column-end': gridColumnEnd }" *ngIf="!!hadItemsBeforeFiltering && !!noResultsMessage && !items?.length">
        {{ noResultsMessage }}
      </div>
      <div *ngIf="showEmptyDiv" class="nested-table-row" [ngStyle]="{'grid-column-end': gridColumnEnd }">
        <ng-content select=".empty-table"></ng-content>
      </div><!-- Second way: pass in a null state div directly-->
      <ng-container *ngFor="let item of visibleItems; trackBy: trackById">
        <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{item: item }" ></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="nested">
      <ng-container *ngFor="let id of nestedIds; trackBy: trackById" [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{item: nestedData[id] }" >
      </ng-container>
    </ng-container>
  </div>
</div>
<paginator 
  [pageIndex]="pageIndex" 
  [itemsPerPage]="itemsPerPage" 
  [pages]="pages"
  (setPageIndex)="setPageIndex($event)"
  (updateItemsPerPage)="updateItemsPerPage($event)"
></paginator>




<!-- Cell Templates -->
<ng-template #tableImage let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.url">&ndash;</div>
  <img class="table-image" [ngClass]="{short: condensedView || nested}" *ngIf="data.url" [src]="data.url" [title]="data.title ? data.title : ''">
</ng-template>

<ng-template #tableTextLights let-item="item", let-data="data", let-column="column">
  <div *ngIf="!!data && !!data.greyText" class="text grey-text">{{ data.greyText }}</div>
  <div *ngIf="!!data && !data.greyText" class="light-holder">
    <traffic-light *ngFor="let light of data['lights']" [color]="light.color" [text]="light.text"></traffic-light>
  </div>
  <div *ngIf="!data">
    {{ column | json }}
  </div>
  <copy-url *ngIf="!!data && data.url" [fullUrl]="data.url"></copy-url>
</ng-template>

<ng-template #tableLightsMap let-item="item", let-data="data", let-column="column">
  <ng-container 
    [ngTemplateOutlet]="tableTextLights" 
    [ngTemplateOutletContext]="{item: item, data: data[parentId], column: column}">
  </ng-container>
</ng-template>

<ng-template #tableText let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.text">&ndash;</div>
  <div class="text" [ngClass]="{ strikethrough: data.strikethrough, nested: nested }" [innerHTML]="helpers.strWithBreak(data.text)"></div>
</ng-template>

<ng-template #tableHHMM let-item="item", let-data="data", let-column="column">
  <div class="text" [ngClass]="{ warning: data.warning }">{{ data.time.negative ? "-" : ""}}{{ data.time.h }}:{{ data.time.m < 10 ? '0' : '' }}{{ data.time.m }}</div>
</ng-template>

<ng-template #boldText let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.text">&ndash;</div>
  <div class="text bold" [innerHTML]="helpers.strWithBreak(data.text)"></div>
</ng-template>

<ng-template #tableEmail let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.text">&ndash;</div>
  <a (click)="$event.stopPropagation()" *ngIf="!!data.text" class="secondary_link" href="mailto:{{data.text}}">{{data.text}}</a>
</ng-template>

<ng-template #tableLink let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.url">&ndash;</div>
  <div class="text" *ngIf="!!data.NA">N/A</div>
  <a (click)="helpers.goToUrl($event, data.url)" *ngIf="!data.NA && !!data.url" class="secondary_link">{{data.url}}</a>
</ng-template>

<ng-template #tableSocial let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data?.length">&ndash;</div>
  <div class="social-links-holder" *ngIf="!!data && !!data.length">
    <a [href]="socialLink.url" target="_blank" (click)="$event.stopPropagation()" *ngFor="let socialLink of data" class="social-icon-holder">
      <icon [icon]="'SOCIAL_' + socialLink.type"  [class]="'social_' + socialLink.type.toLowerCase()"></icon>
    </a>
  </div>
</ng-template>

<ng-template #tableWorker let-item="item", let-data="data", let-column="column">
  <worker-card [hidePhoto]="condensedView && !nested" [size]="nested ? 24 : 36" (click)="$event.stopPropagation()" [worker]="data"></worker-card>
</ng-template>

<ng-template #tableUser let-item="item", let-data="data", let-column="column">
  <div class="user_photo_holder">
    <photo *ngIf="(!condensedView || nested) && !data.hidePhoto" class="inner_user" [data]="{title: data.name, photoURL: data.photoUrl }" [size]="nested ? 24 : 36"></photo>
    <div (click)="column?.templateFunction ? column?.templateFunction($event, item) : null" [ngClass]="{hoverable: !!column?.templateFunction}">
      <span class="user_name">{{ data['name'] }}</span>
      <ng-container *ngIf="!!data.createdType">
        <br/>
        <span class="hint">({{ data.createdType }})</span>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #tableEntity let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data?.entity">&ndash;</div>
  <div class="text" *ngIf="!!data.entity" [innerHTML]="(data.entity.name || 'Unnamed') + '<span class=\'hint\'><br/>' + '(' + data.entity.type + ')</span>'"></div>
</ng-template>

<ng-template #tableAccount let-item="item", let-data="data", let-column="column">
  <div class="user_photo_holder">
    <photo *ngIf="!condensedView || nested" class="inner_user" [data]="{title: data.name, photoURL: data.photoUrl }" [size]="nested ? 24 : 36"></photo>
    <div (click)="column?.templateFunction ? column?.templateFunction($event, item) : null" class="user_name" [ngClass]="{hoverable: !!column?.templateFunction}">
      {{ data['name'] }}
    </div>
  </div>
</ng-template>

<ng-template #tableLabels let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.length">&ndash;</div>
  <div class="label-holder" *ngIf="!!data.length">
    <label-item *ngFor="let label of data" [color]="label.color" [label]="label.label"></label-item>
  </div>
</ng-template>

<ng-template #tableDate let-item="item", let-data="data", let-column="column">
  <div class="text" [ngClass]="{red: data.red}">{{ data.HHMMText }}<span *ngIf="!data.day">{{ data.date | date: 'd MMMM y' }}</span><span *ngIf="!!data.day">{{ data.day }}</span></div>
</ng-template>

<ng-template #iconText let-item="item", let-data="data", let-column="column">
  <icon *ngIf="!!data.icon" class="iconText" [icon]="data.icon"></icon> <div class="text">{{ data.text }}</div>
</ng-template>

<ng-template #tableCheck let-item="item", let-data="data", let-column="column">
  <icon (click)="menuDisabled ? null : toggleIcon($event, 'check', item)" class="task-check-circle" [ngClass]="{ disabled: menuDisabled }" [icon]="data.on ? 'task_complete_24px' : 'task_incomplete_24px'"></icon> <div class="text">{{ data.text }}</div>
</ng-template>

<ng-template #tableFlag let-item="item", let-data="data", let-column="column">
  <icon (click)="menuDisabled ? null : toggleIcon($event, 'flag', item)" [ngClass]="{ disabled: menuDisabled, flag: data.flagged, flagOutline: !data.flagged}" [icon]="data.flagged ? 'flag_on_24px' : 'flag_off_24px'"></icon> <div class="text">{{ data.text }}</div>
</ng-template>

<ng-template #tableComments let-item="item", let-data="data", let-column="column">
  <div class="comment-holder">
    <icon [class]="!data.comments ? 'commentless' : 'commentful'"  [icon]="'chat_24px'"></icon>
    <div *ngIf="!!data.unseenComments" class="chat_dot">{{ data.unseenComments }}</div>
  </div>
</ng-template>

<ng-template #tableFiles let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.files">&ndash;</div>
  <ng-container *ngIf="!!data.files">
    <icon icon="attachment_18px"></icon>
    <div class="icon_text">{{ data.files }}</div>
  </ng-container>
</ng-template>

<ng-template #taskStatus let-item="item", let-data="data", let-column="column">
  <task-status-dropdown [task]="data.task"></task-status-dropdown>
</ng-template>

<ng-template #tableStars let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data?.stars">&ndash;</div>
  <stars *ngIf="!!data?.stars" [maxStars]="data.maxStars" [stars]="data.stars" [tiny]="true"></stars>
</ng-template>


<ng-template #tableUpdatedText let-item="item", let-data="data", let-column="column">
  <div class="dash" *ngIf="!data.lastUpdated">&ndash;</div>
  <div class="updated-holder" *ngIf="!!data.lastUpdated">
    <div class="update-time">{{ data.lastUpdated | date: 'h:mmaaaaa\'m\', d MMM yyyy' }}</div>
    <div class="updater">{{ data.updater }}</div>
  </div>
</ng-template>



